import { UserRound, HeartHandshake, BellRing, MessageSquareText, ArrowRight } from "lucide-react";
import { useJamaah } from "@/context/JamaahContext";

const CARDS = [
  { id: "donasi", label: "Donasi Saya", desc: "Riwayat infaq, sedekah, dan zakat Anda beserta statusnya.", icon: HeartHandshake },
  { id: "langganan", label: "Langganan Notifikasi", desc: "Pilih kegiatan yang ingin diingatkan via WhatsApp.", icon: BellRing },
  { id: "profil", label: "Profil Saya", desc: "Perbarui data diri, foto, dan kata sandi akun Anda.", icon: UserRound },
  { id: "saran", label: "Saran & Aspirasi", desc: "Sampaikan masukan langsung kepada pengurus DKM.", icon: MessageSquareText },
];

export const PortalBeranda = ({ onNavigate }) => {
  const { jamaah } = useJamaah();
  return (
    <div className="space-y-8" data-testid="portal-beranda">
      <div className="rounded-3xl border border-emerald-900/10 bg-white p-7">
        <p className="font-arabic text-2xl gold-text">أَهْلًا وَسَهْلًا</p>
        <h2 className="mt-2 text-2xl font-bold text-emerald-950" data-testid="beranda-welcome">Selamat datang, {jamaah.name}</h2>
        <p className="mt-2 text-sm text-slate-600 leading-relaxed max-w-2xl">
          Portal Jamaah Al-Iman Digital adalah ruang pribadi Anda untuk memantau donasi, menerima pengingat kegiatan masjid via WhatsApp,
          mengelola data diri, dan menyampaikan aspirasi kepada pengurus. Pilih menu di bawah untuk memulai.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {CARDS.map((c) => (
          <button key={c.id} onClick={() => onNavigate(c.id)} className="group text-left rounded-2xl border border-emerald-900/10 bg-white p-6 hover:border-emerald-700 hover:shadow-md transition-all" data-testid={`beranda-card-${c.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="h-12 w-12 rounded-2xl emerald-bg text-[#d4af37] flex items-center justify-center shrink-0"><c.icon size={22} /></div>
              <ArrowRight size={18} className="text-slate-300 group-hover:text-emerald-700 group-hover:translate-x-1 transition-all" />
            </div>
            <p className="mt-4 font-bold text-emerald-950">{c.label}</p>
            <p className="mt-1 text-sm text-slate-600">{c.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
};
